import { render, staticRenderFns } from "./ModalInviteTalent.vue?vue&type=template&id=132c9343&scoped=true&"
import script from "./ModalInviteTalent.vue?vue&type=script&lang=js&"
export * from "./ModalInviteTalent.vue?vue&type=script&lang=js&"
import style1 from "./ModalInviteTalent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c9343",
  null
  
)

export default component.exports